/**
 * 현재 라우트(pathname)를 요청 맥락 store에 동기화합니다.
 * API 요청 시 X-Screen, X-Request-Action 헤더로 백엔드 로그에 표시됩니다.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useRequestContextStore from '@entities/ui/model/useRequestContextStore';

/**
 * pathname → screen 식별자 매핑 (백엔드 로그용)
 */
function getScreenFromPathname(pathname) {
  if (!pathname || pathname === '/') return '';
  if (pathname.startsWith('/login') || pathname.startsWith('/admin/login')) return 'login';
  if (pathname === '/approval/new-document') return 'form-selection';
  if (pathname.startsWith('/approval/new-document/write')) return 'document-write';
  if (pathname.startsWith('/approval/drafter')) return 'approval-drafter';
  if (pathname.startsWith('/approval/approver')) return 'approval-approver';
  if (pathname.startsWith('/approval/reference')) return 'approval-reference';
  if (pathname.startsWith('/approval/execution')) return 'approval-execution';
  if (pathname.startsWith('/approval/temporary-archive')) return 'temporary-archive';
  if (pathname.startsWith('/approval/vacation/request')) return 'vacation-request';
  if (pathname.startsWith('/approval/vacation/approval')) return 'vacation-approval';
  if (pathname.startsWith('/approval/settings/sign')) return 'settings-sign';
  if (pathname.startsWith('/approval/settings/password')) return 'settings-password';
  if (pathname.startsWith('/approval/settings/approval-line')) return 'settings-approval-line';
  if (pathname.startsWith('/approval/settings/notification')) return 'settings-notification';
  if (pathname.startsWith('/admin/documents')) return 'admin-documents';
  if (pathname.startsWith('/admin/vacation')) return 'admin-vacation';
  if (pathname.startsWith('/admin/employees')) return 'admin-employees';
  if (pathname.startsWith('/admin/organization')) return 'admin-organization';
  if (pathname.startsWith('/admin/forms/document/edit')) return 'admin-forms-document-edit';
  if (pathname.startsWith('/admin/forms/document/add')) return 'admin-forms-document-add';
  if (pathname.startsWith('/admin/forms/document')) return 'admin-forms-document';
  if (pathname.startsWith('/admin/forms/approval-line-reference'))
    return 'admin-forms-approval-line-reference';
  if (pathname.startsWith('/admin/inquiry')) return 'admin-inquiry';
  return '';
}

function RequestContextSync() {
  const location = useLocation();
  const setRequestContext = useRequestContextStore((state) => state.setRequestContext);

  useEffect(
    function syncPathnameToRequestContext() {
      const screen = getScreenFromPathname(location.pathname);
      setRequestContext(screen, '');
    },
    [location.pathname, setRequestContext],
  );

  return null;
}

export default RequestContextSync;
